import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import './style.css';

import { PageComponent, Button, Input, Card } from '../../components';
import Api from '../../Api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isCheckingAutoLogin, setIsCheckingAutoLogin] = useState(true);
  const [autoLoginFailed, setAutoLoginFailed] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check for auto-login params
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const emailParam = params.get('email');
    const senhaParam = params.get('senha');

    // Se já estiver logado e não houver parâmetros de auto-login, redirecionar para home
    const storedToken = localStorage.getItem('authToken');
    if (storedToken && !token && (!emailParam || !senhaParam)) {
        navigate('/', { replace: true });
        return;
    }

    if (token) {
      handleAutoLogin(token);
    } else if (emailParam && senhaParam) {
        if (emailParam) setEmail(emailParam);
        if (senhaParam) setPassword(senhaParam);
        handleManualAutoLogin(emailParam, senhaParam);
    } else {
        if (emailParam) setEmail(emailParam);
        setIsCheckingAutoLogin(false);
    }
  }, [location]);

  async function handleAutoLogin(token) {
    setLoading(true);
    setIsCheckingAutoLogin(true);
    try {
        const data = await Api.login(null, null, token);
        if (data && data.token) {
            localStorage.setItem('authToken', data.token);
            if (data.user) {
                localStorage.setItem('authUser', JSON.stringify(data.user));
            }
            navigate('/', { replace: true });
        } else {
            setError(data && data.error ? data.error : 'Login automático falhou.');
            setLoading(false);
            setIsCheckingAutoLogin(false);
            setAutoLoginFailed(true);
        }
    } catch (err) {
        setError('Erro no login automático.');
        setLoading(false);
        setIsCheckingAutoLogin(false);
        setAutoLoginFailed(true);
    }
  }

  async function handleManualAutoLogin(email, password) {
    setLoading(true);
    setIsCheckingAutoLogin(true);
    try {
        const data = await Api.login(email, password);
        if (data && data.token) {
            localStorage.setItem('authToken', data.token);
            if (data.user) {
                localStorage.setItem('authUser', JSON.stringify(data.user));
            }
            navigate('/', { replace: true });
        } else {
            setError(data && data.error ? data.error : 'Credenciais inválidas.');
            setLoading(false);
            setIsCheckingAutoLogin(false);
            setAutoLoginFailed(true);
        }
    } catch (err) {
        setError('Erro ao entrar.');
        setLoading(false);
        setIsCheckingAutoLogin(false);
        setAutoLoginFailed(true);
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await Api.login(email, password);

      if (data && data.token) {
        localStorage.setItem('authToken', data.token);

        if (data.user) {
          localStorage.setItem('authUser', JSON.stringify(data.user));
        }

        navigate('/', { replace: true });
      } else {
        setError(data && data.error ? data.error : 'Credenciais inválidas.');
      }
    } catch (err) {
      setError('Erro ao entrar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <PageComponent authenticatedPage={false}>
      {isCheckingAutoLogin ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
            <img src="logo_black.png" alt="Maxximus Tecnologia" style={{ width: '150px', marginBottom: '20px' }} />
            <h2 style={{ color: '#555' }}>Carregando...</h2>
        </div>
      ) : autoLoginFailed ? (
        <div className="login-page">
            <div className="login-panel">
                 <Card className="login-card">
                     <div style={{ textAlign: 'center', padding: '20px' }}>
                        <h3 style={{ color: '#ef4444', marginBottom: '10px' }}>Falha no Login Automático</h3>
                        <p style={{ marginBottom: '20px', color: '#666' }}>{error}</p>
                        <Button 
                            onClick={() => {
                                setAutoLoginFailed(false);
                                setIsCheckingAutoLogin(false);
                                setError('');
                            }} 
                            fullWidth
                        >
                            Tentar Login Manual
                        </Button>
                     </div>
                 </Card>
            </div>
        </div>
      ) : (
        <div className="login-page">
        <div className="login-panel">
          <div className="login-brand">
            <img src="logo_black.png" alt="Maxximus Tecnologia" className="login-logo" />
            <h1 className="login-title">Gestão inteligente para o seu negócio</h1>
            <p className="login-description">
              Controle financeiro, funcionarios, ordens de serviço, estoque e muito mais.
            </p>
          </div>
          <Card className="login-card">
            <h2 className="login-card-title">Acesse sua conta</h2>
            <p className="login-card-subtitle">
              Entre para acompanhar indicadores, lançamentos e operações do dia a dia.
            </p>
            <form className="login-form" onSubmit={handleSubmit}>
              <Input
                id="email"
                type="email"
                label="E-mail"
                placeholder="seu@email.com"
                value={email}
                onChange={event => setEmail(event.target.value)}
              />
              <Input
                id="password"
                type="password"
                label="Senha"
                placeholder="Digite sua senha"
                value={password}
                onChange={event => setPassword(event.target.value)}
              />
              {error && <div className="login-error">{error}</div>}
              <div className="login-actions">
                <Button type="submit" fullWidth className="login-submit" disabled={loading}>
                  {loading ? 'Entrando...' : 'Entrar'}
                </Button>
              </div>
              <div className="login-secondary-actions">
                <button type="button" className="login-link-button">
                  Esqueci minha senha
                </button>
              </div>
              <div className="login-secondary-actions">
                <span className="login-link-text">
                  Não tem conta?
                  {' '}
                  <Link to="/register" className="login-link-button">
                    Cadastre-se
                  </Link>
                </span>
              </div>
            </form>
          </Card>
</div>
        </div>
      )}
    </PageComponent>
  );
}
